import React, {useContext} from 'react'
import {Typography, FormControlLabel, Radio} from '@mui/material'
import {Trans} from 'react-i18next'
import productTypeIsOneOf from '../../../lib/productTypeIsOneOf'
import {ComplaintState, ProductTypeOptions} from '../../../contexts/types'
import isSameDay from 'date-fns/isSameDay'
import {OrgCustomizationContext} from "../../../themes/OrgCustomizationProvider";

type OsseointegrationOptionsProps = {
    productType: ProductTypeOptions
    complaint: ComplaintState
}

const OsseointegrationOptions: React.FC<OsseointegrationOptionsProps> = ({
                                                                             productType,
                                                                             complaint,
                                                                         }) => {
    const {t, tns} = useContext(OrgCustomizationContext)

    if (complaint.generalComplaint.wasPatientInvolved === 'YES' && complaint.generalComplaint.wasProductPlaced === 'NO') return null;

    return (
        <>
            {/* Osseointegration */}
            {productTypeIsOneOf(['IMPLANT'], productType) && (
                <>
                    <Typography variant='body1' color='secondary.contrastText'>
                        <Trans i18nKey={tns('cti_complaint_osseointegration')}>
                            -
                            <Typography
                                component='span'
                                sx={{color: 'primary.main'}}
                            >
                                -
                            </Typography>
                            -
                        </Trans>
                    </Typography>

                    < FormControlLabel
                        value='WITHIN_365_DAYS'
                        control={<Radio/>}
                        label={t('cti_option_within_365_days') as string}
                    />

                    <FormControlLabel
                        value='MORE_THAN_365_DAYS'
                        control={<Radio/>}
                        label={t('cti_option_more_than_365_days') as string}
                    />

                    {isSameDay(
                        complaint.complaintType.dateOfOccurrence as Date,
                        complaint.treatmentDates.dateOfTreatment as Date
                    ) && (
                        <FormControlLabel
                            value='LACK_STABILITY'
                            control={<Radio/>}
                            label={t('cti_option_lack_stability') as string}
                        />
                    )}

                    <FormControlLabel
                        value='PART_MIGRATES'
                        control={<Radio/>}
                        label={t('cti_option_part_migrates') as string}
                    />
                </>
            )}
        </>
    )
}

export default OsseointegrationOptions
